import * as Sentry from "@sentry/angular";
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import localeRu from '@angular/common/locales/ru';
import { appConfig } from './app/app.config';


if (environment.production) {
  Sentry.init({
    dsn: "https://b26c200a5ce44bd3a310d8e4743c9e2a@o499816.ingest.us.sentry.io/5578766",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  });

  enableProdMode();
}

registerLocaleData(localeRu);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
